import { createSlice } from "@reduxjs/toolkit";

const stateSlice = createSlice({
  name: "new/bom/state",
  initialState: {
    deleteConfirmation: false,
    selectedEmployee: "",
    selectedFinishGoods: [],
    selectedRawMaterial: [],
    newDialog: false,
  },
  reducers: {
    toggleDeleteConfirmation: (state, action) => {
      state.deleteConfirmation = action.payload;
    },
    setSelectedFinishGoods: (state, action) => {
      state.selectedFinishGoods = [
        ...state.selectedFinishGoods,
        action.payload,
      ];
    },
    setSelectedRawMaterial: (state, action) => {
      state.selectedRawMaterial = [
        ...state.selectedRawMaterial,
        action.payload,
      ];
    },
    toggleNewDialog: (state, action) => {
      state.newDialog = action.payload;
    },
  },
});

export const {
  toggleDeleteConfirmation,
  setSelectedFinishGoods,
  setSelectedRawMaterial,
  toggleNewDialog,
} = stateSlice.actions;

export default stateSlice.reducer;
